import React from 'react';
import { t, defineMessages } from '@sm/intl';
import { createURL } from '@sm/utils';
import { TopBarFull } from '../TopBarFull';
import {
  TopBarFullCtaColors,
  TopBarFullUseCaseEnums,
  TopBarFullImagePositions,
} from '../TopBarFullEnums';
import UcFormsApplicationsImage from './imageComponents/UcFormsApplicationsImage';

const DEFAULT_UTSOURCE2 = 'full_misc_upsell_forms_applications';
const DEFAULT_COPY = defineMessages({
  HEADLINE: {
    id: 'UseCaseFormsApplicationsTopBarFull.headline',
    defaultMessage: 'Accept payments along with survey responses',
    description: '[Type: Paragraph][Vis.: low] - Top bar full message',
  },
  MESSAGE: {
    id: 'UseCaseFormsApplicationsTopBarFull.message',
    defaultMessage:
      'Get fees and completed applications at the same time and in the same place.',
    description: '[Type: Paragraph][Vis.: low] - Top bar full message',
  },
  CTA_TEXT: {
    id: 'UseCaseFormsApplicationsTopBarFull.ctaText',
    defaultMessage: 'SEE ALL PLANS',
    description: '[Type: Button][Vis.: low] - Top bar full cta text',
  },
});

const INITIATED_DRAFTED_UTSOURCE2 = 'full_initiate_upsell_forms_applications';
const INITIATED_DRAFTED_COPY = defineMessages({
  HEADLINE: {
    id: 'UseCaseFormsApplicationsTopBarFull.headlineInitiated',
    defaultMessage: 'Accept payments along with survey responses',
    description: '[Type: Paragraph][Vis.: low] - Top bar full message',
  },
  MESSAGE: {
    id: 'UseCaseFormsApplicationsTopBarFull.messageInitiated',
    defaultMessage:
      'Get fees and completed applications at the same time and in the same place.',
    description: '[Type: Paragraph][Vis.: low] - Top bar full message',
  },
  CTA_TEXT: {
    id: 'UseCaseFormsApplicationsTopBarFull.ctaTextInitiated',
    defaultMessage: 'SEE ALL PLANS',
    description: '[Type: Button][Vis.: low] - Top bar full cta text',
  },
});

const TESTED_ACTIVATED_UTSOURCE2 = 'full_activate_upsell_forms_applications';
const TESTED_ACTIVATED_COPY = defineMessages({
  HEADLINE: {
    id: 'UseCaseFormsApplicationsTopBarFull.headlineTested',
    defaultMessage: 'Give everyone a say with unlimited responses',
    description: '[Type: Paragraph][Vis.: low] - Top bar full message',
  },
  MESSAGE: {
    id: 'UseCaseFormsApplicationsTopBarFull.messageTested',
    defaultMessage:
      'Unlock answers from all of your respondents with an upgraded plan.',
    description: '[Type: Paragraph][Vis.: low] - Top bar full message',
  },
  CTA_TEXT: {
    id: 'UseCaseFormsApplicationsTopBarFull.ctaTextTested',
    defaultMessage: 'SEE ALL PLANS',
    description: '[Type: Button][Vis.: low] - Top bar full cta text',
  },
});

const DEPLOYED_UTSOURCE2 = 'full_deploy_upsell_forms_applications';
const DEPLOYED_COPY = defineMessages({
  HEADLINE: {
    id: 'UseCaseFormsApplicationsTopBarFull.headlineDeployed',
    defaultMessage: 'Export and print for easier sharing',
    description: '[Type: Paragraph][Vis.: low] - Top bar full message',
  },
  MESSAGE: {
    id: 'UseCaseFormsApplicationsTopBarFull.messageDeployed',
    defaultMessage:
      'Share completed applications and forms with colleagues or save them with advanced options.',
    description: '[Type: Paragraph][Vis.: low] - Top bar full message',
  },
  CTA_TEXT: {
    id: 'UseCaseFormsApplicationsTopBarFull.ctaTextDeployed',
    defaultMessage: 'SEE ALL PLANS',
    description: '[Type: Button][Vis.: low] - Top bar full cta text',
  },
});

export type UseCaseFormsApplicationsTopBarFullProps = {
  variation?: TopBarFullUseCaseEnums | null;
};

const VariationToCopy = {
  [TopBarFullUseCaseEnums.InitiatedDrafted]: {
    copy: INITIATED_DRAFTED_COPY,
    utSource2: INITIATED_DRAFTED_UTSOURCE2,
  },
  [TopBarFullUseCaseEnums.TestedActivated]: {
    copy: TESTED_ACTIVATED_COPY,
    utSource2: TESTED_ACTIVATED_UTSOURCE2,
  },
  [TopBarFullUseCaseEnums.Deployed]: {
    copy: DEPLOYED_COPY,
    utSource2: DEPLOYED_UTSOURCE2,
  },
};

export const UseCaseFormsApplicationsTopBarFull: React.FC<UseCaseFormsApplicationsTopBarFullProps> = ({
  variation, // TODO: get real data
}) => {
  const [copy, utSource2] =
    variation && variation in VariationToCopy
      ? [VariationToCopy[variation].copy, VariationToCopy[variation].utSource2]
      : [DEFAULT_COPY, DEFAULT_UTSOURCE2];
  return (
    <TopBarFull
      headline={t(copy.HEADLINE)}
      message={t(copy.MESSAGE)}
      image={() => <UcFormsApplicationsImage />}
      imagePosition={TopBarFullImagePositions.low}
      ctaText={t(copy.CTA_TEXT)}
      ctaLink={createURL(`/pricing/upgrade`, {
        ut_source: 'topbar',
        ut_source2: utSource2,
      })}
      ctaNewTab={true}
      ctaColor={TopBarFullCtaColors.alt}
    />
  );
};

export default UseCaseFormsApplicationsTopBarFull;
